import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { getPageShellDataSafely } from "@/services/contenful/getPageShellDataSafe";
import { lwAppName } from "@/constants";
import { getProductDetailsFromServer } from "@/services/server/pdp.server";
import { usePathname, useSearchParams } from "next/navigation";
import Head from "next/head";
import Landing from "@/components/landing";
const Loader = dynamic(() => import("@/components/loader"));
const DetailsComponent = dynamic(() => import("@/components/detailsComponent"));

const LandingPage = ({
  pageData = {},
  locale = "en",
  pdpData = {},
  compareMappingsData = {},
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  if (router.isFallback) {
    return <Loader loading={router.isFallback} />;
  }

  const {
    ProductDescriptionProduct_s: pageTitle = "",
    ProductNarrativeDescription_s: productDescription = "",
  } = pdpData || {};

  return (
    <>
      <Head>
        <title>{`${pageTitle}`}</title>
        {productDescription && (
          <meta name="description" content={productDescription} />
        )}
      </Head>
      <DetailsComponent
        key={`${locale}-${pathname}-${searchParams.toString()}`}
        productDetailsData={pdpData}
        skuInfo={router?.query?.sku || ""}
        compareMappingsData={compareMappingsData}
      />
      {pageData && Object.keys(pageData).length > 0 && (
        <div className="mb-[9.6px]">
          <Landing pageData={pageData} />
        </div>
      )}
    </>
  );
};

export async function getServerSideProps({
  req,
  params,
  preview,
  locale,
  query,
}) {
  const { slug = "/" } = params;
  const {
    items,
    headerNavigationData,
    footerNavigationData,
    promoBannerData,
    worldwideMenuData,
    compareMappingsData,
  } = await getPageShellDataSafely({
    slug: `/product-details`,
    preview,
    contentType: "brazilLandingPage",
    fetchEntryBySlug: true,
    locale,
  });

  const pageData = items?.[0]?.fields ?? null;

  const { pageSections = [] } = pageData ?? {};

  const pdpSlug = slug;

  const { sku = "" } = query || {};

  const profileName = `profile_${lwAppName}_PDP`;
  const collections = lwAppName;

  const pdpData = await getProductDetailsFromServer(
    profileName,
    collections,
    pdpSlug,
    locale,
    sku
  );

  return {
    props: {
      pageData,
      headerNavigationData,
      footerNavigationData,
      promoBannerData,
      world: worldwideMenuData,
      locale,
      pdpData,
      compareMappingsData,
      params,
    },
  };
}

LandingPage.propTypes = {
  pageData: PropTypes.object,
  locale: PropTypes.string,
  pdpData: PropTypes.object,
  compareMappingsData: PropTypes.object,
  facetLabelsState: PropTypes.object,
  categoryConfig: PropTypes.string,
  params: PropTypes.object,
};

export default LandingPage;
